import { getPricingApiConfig } from '../config/actions';
import { getProductTypeUrlSuffix } from './get-product-type-url-suffix';
/**
 * @internal
 */
export var getFetchPricesUrlPost = function (productType) {
    if (productType === void 0) { productType = "f" /* Family */; }
    var baseUrl = getPricingApiConfig().baseUrl;
    var suffix = getProductTypeUrlSuffix(productType);
    return baseUrl + "/v1/" + suffix;
};
